// Module
var code = "<div class=\"paymentIframeModal t-paymentIframeModal\"> <div class=\"paymentIframeModal_wrapper\"> <iframe ref=\"checkoutIframe\" class=\"paymentIframeModal_checkoutIframe\" :src=\"checkoutIframeSrc\" @load=\"handleCheckoutIframeLoadEvent\"></iframe> <div class=\"paymentIframeModal_loader\"> <cSpinner/> </div> </div> </div> ";
// Exports
export default code;